import React from 'react';

// Tend Logo - Icon only
export const TendLogoIcon = ({ className = "w-10 h-10", color = "#2C3327" }) => (
  <svg 
    viewBox="0 0 92 132" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path 
      d="M46 126C46 126 46 66 46 6" 
      stroke={color} 
      strokeWidth="12" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M6 66C32.6667 92.6667 59.3333 82.6667 86 36" 
      stroke={color} 
      strokeWidth="12" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
);

// Tend Logo - Icon with background circle
export const TendLogoWithBg = ({ className = "w-12 h-12", bgColor = "#87A878", iconColor = "#F5F3EF" }) => (
  <div 
    className={`rounded-full flex items-center justify-center ${className}`}
    style={{ backgroundColor: bgColor }}
  >
    <TendLogoIcon className="w-1/2 h-1/2" color={iconColor} />
  </div>
);

// Tend Text Logo SVG
export const TEND_LETTERS = [
  ['t', 'M13 38.4881H50.056V48.1841H13V38.4881ZM25.288 25.4321H37.768V86.2001H25.288V25.4321Z'],
  ['e', 'M98.8965 70.3601H110.992C110.48 73.6241 109.104 76.5361 106.864 79.0961C104.688 81.6561 101.712 83.6721 97.9365 85.1441C94.1605 86.6161 89.5525 87.3521 84.1125 87.3521C78.0325 87.3521 72.6565 86.3921 67.9845 84.4721C63.3125 82.4881 59.6645 79.6401 57.0405 75.9281C54.4165 72.2161 53.1045 67.7361 53.1045 62.4881C53.1045 57.2401 54.3845 52.7601 56.9445 49.0481C59.5045 45.2721 63.0565 42.3921 67.6005 40.4081C72.2085 38.4241 77.5845 37.4321 83.7285 37.4321C90.0005 37.4321 95.2165 38.4241 99.3765 40.4081C103.536 42.3921 106.608 45.4001 108.592 49.4321C110.64 53.4001 111.504 58.4881 111.184 64.6961H65.6805C66.0005 67.1281 66.8965 69.3361 68.3685 71.3201C69.9045 73.3041 71.9525 74.8721 74.5125 76.0241C77.1365 77.1761 80.2405 77.7521 83.8245 77.7521C87.7925 77.7521 91.0885 77.0801 93.7125 75.7361C96.4005 74.3281 98.1285 72.5361 98.8965 70.3601ZM83.1525 46.9361C78.5445 46.9361 74.8005 47.9601 71.9205 50.0081C69.0405 51.9921 67.1845 54.4561 66.3525 57.4001H98.8005C98.4805 54.2001 96.9445 51.6721 94.1925 49.8161C91.5045 47.8961 87.8245 46.9361 83.1525 46.9361Z'],
  ['n', 'M119.031 38.2002H126.711V86.2002H119.031V38.2002ZM143.223 37.2402C145.783 37.2402 148.087 37.6242 150.135 38.3922C152.183 39.1602 153.911 40.2802 155.319 41.7522C156.727 43.2242 157.815 45.0162 158.583 47.1282C159.351 49.1762 159.735 51.5122 159.735 54.1362V86.2002H152.055V56.0562C152.055 52.3442 151.191 49.5602 149.463 47.7042C147.735 45.8482 145.143 44.9202 141.687 44.9202C139.063 44.9202 136.631 45.5922 134.391 46.9362C132.151 48.2802 130.295 50.1362 128.823 52.5042C127.415 54.8082 126.551 57.4962 126.231 60.5682L126.135 55.0002C126.455 52.3122 127.095 49.8802 128.055 47.7042C129.079 45.5282 130.327 43.6722 131.799 42.1362C133.335 40.5362 135.063 39.3202 136.983 38.4882C138.967 37.6562 141.047 37.2402 143.223 37.2402Z'],
  ['d', 'M188.411 87.16C184.571 87.16 181.051 86.104 177.851 83.992C174.715 81.816 172.219 78.872 170.363 75.16C168.507 71.384 167.579 67.096 167.579 62.296C167.579 57.496 168.475 53.208 170.267 49.432C172.059 45.656 174.523 42.68 177.659 40.504C180.795 38.328 184.379 37.24 188.411 37.24C191.995 37.24 194.907 37.912 197.147 39.256C199.451 40.536 201.211 42.328 202.427 44.632C203.643 46.936 204.475 49.592 204.923 52.6C205.435 55.608 205.691 58.84 205.691 62.296C205.691 64.728 205.435 67.384 204.923 70.264C204.411 73.08 203.515 75.8 202.235 78.424C201.019 80.984 199.291 83.096 197.051 84.76C194.811 86.36 191.931 87.16 188.411 87.16ZM190.331 79.864C193.595 79.864 196.283 79.064 198.395 77.464C200.571 75.864 202.171 73.752 203.195 71.128C204.219 68.44 204.731 65.496 204.731 62.296C204.731 58.776 204.187 55.704 203.099 53.08C202.075 50.392 200.475 48.312 198.299 46.84C196.187 45.304 193.531 44.536 190.331 44.536C185.531 44.536 181.819 46.232 179.195 49.624C176.571 52.952 175.259 57.176 175.259 62.296C175.259 65.688 175.899 68.728 177.179 71.416C178.523 74.04 180.315 76.12 182.555 77.656C184.859 79.128 187.451 79.864 190.331 79.864ZM204.731 19H212.411V86.2H205.403C205.275 84.792 205.115 83.128 204.923 81.208C204.795 79.288 204.731 77.752 204.731 76.6V19Z'],
];

export const TendTextLogo = ({ className = "h-6", color = "#2C3327" }) => (
  <svg 
    viewBox="0 0 226 106" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={{ width: 'auto' }}
  >
    {TEND_LETTERS.map(([k, d]) => <path key={k} d={d} fill={color} />)}
  </svg>
);

// Tend Logo - Full logo with icon and text logo
export const TendLogoFull = ({ className = "", iconSize = "w-8 h-8", textSize = "h-5" }) => (
  <div className={`flex items-center gap-2 ${className}`}>
    <TendLogoIcon className={iconSize} color="#2C3327" />
    <TendTextLogo className={textSize} color="#2C3327" />
  </div>
);

// Tend Logo - Large text only (for footer watermark)
export const TendLogoText = ({ className = "text-6xl", color = "#2C3327" }) => (
  <span className={`font-display tracking-tight ${className}`} style={{ color }}>Tend</span>
);

export default TendLogoIcon;
